import * as React from 'react'

import { Box, type CalloutType } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'

interface Props {
  type: CalloutType
  description: string
  action?: React.ReactElement
  onClose?: () => void
  closeLabel?: string
  link?: React.ReactElement
  compact?: boolean
  title?: string
}

const BaseNotification = ({
  type,
  description,
  action,
  onClose,
  closeLabel,
  link,
  compact = false,
  title,
}: React.PropsWithChildren<Props>) => {
  return (
    <Box width="full" minWidth="s600" paddingBottom="s24">
      <Callout
        type={type}
        description={description}
        onRemove={onClose}
        removeLabel={closeLabel}
        action={action}
        link={link}
        compact={compact}
        title={title}
      />
    </Box>
  )
}

export default BaseNotification
